export const setAllSchemeDetails=(data)=>{
    return {
        type: "SET_ALL_SCHEME_DETAILS",
        info: data,
    }
}
export const nullAllSchemeDetails=()=>{
    return{
        type:"NULL_ALL_SCHEME_DETAILS",
        info: null
    }
}
export const getAllSchemeDetails=()=>{
    return {
        type: "GET_ALL_SCHEME_DETAILS",
        
    }
}
